import React, { FC } from 'react';

import { Items } from './Items';

import './web.scss';

export const Web: FC = () => {
  return <Items className='navigation-web' />;
};
